import { Dictionary, Record, String, Literal, Union, Array, Boolean } from 'runtypes'
import { Applications, Brands, ContextViews } from './types/enum'

const ApplicationsUnion = Union(
	Literal(Applications.SEABISCUIT_NA),
	Literal(Applications.SFRA_APAC_KR),
	Literal(Applications.SFRA_APAC_SEA_TH),
	Literal(Applications.SFRA_EU),
	Literal(Applications.SHOPAPP_ANDROID),
	Literal(Applications.SHOPAPP_IOS),
	Literal(Applications.UA_NEXT),
)

const BrandsUnion = Union(
	Literal(Brands.ADMIN),
	Literal(Brands.APP_US),
	Literal(Brands.NEXT_UK),
	Literal(Brands.WEB_AU),
	Literal(Brands.WEB_CA),
	Literal(Brands.WEB_CH),
	Literal(Brands.WEB_DE),
	Literal(Brands.WEB_ES),
	Literal(Brands.WEB_EU),
	Literal(Brands.WEB_FR),
	Literal(Brands.WEB_HK),
	Literal(Brands.WEB_IE),
	Literal(Brands.WEB_IT),
	Literal(Brands.WEB_KR),
	Literal(Brands.WEB_MX),
	Literal(Brands.WEB_MY),
	Literal(Brands.WEB_NL),
	Literal(Brands.WEB_NO),
	Literal(Brands.WEB_PL),
	Literal(Brands.WEB_PT),
	Literal(Brands.WEB_SG),
	Literal(Brands.WEB_TH),
	Literal(Brands.WEB_UK),
	Literal(Brands.WEB_US),
)

const ContextViewsUnion = Union(
	Literal(ContextViews.LOGIN),
	Literal(ContextViews.REGISTER),
	Literal(ContextViews.CHALLENGE_AUTHENTICATOR),
	Literal(ContextViews.SELECT_AUTHENTICATOR),
	Literal(ContextViews.RESET_PASSWORD_1),
	Literal(ContextViews.RESET_PASSWORD_2),
	Literal(ContextViews.RESET_PASSWORD_4),
	Literal(ContextViews.RESET_PASSWORD_4a),
	Literal(ContextViews.FAILURE_REDIRECT),
	Literal(ContextViews.SUCCESS_REDIRECT),
)

export const EmailsUnion = Union(
	Literal('ForgotPassword'),
	Literal('EmailChallenge'),
	Literal('PasswordChanged'),
	Literal('ChangeEmailConfirmation'),
	Literal('EmailChangeConfirmation'),
	Literal('RegistrationActivation'),
)

/**
 * - `production` - Okta Production
 * - `preview` - Okta Integration
 * - `development` - Okta Integration's preview functionality (ie. https://auth-dev.ecm.underarmour.com/login/preview)
 */
export const EnvironmentTypesUnion = Union(
	Literal('production'),
	Literal('staging'),
	Literal('development'),
	Literal('sbx1'),
	Literal('sbx2'),
)

export const LocalesUnion = Union(
	Literal('de-ch'),
	Literal('de-at'),
	Literal('de-de'),
	Literal('en-ch'),
	Literal('en-be'),
	Literal('en-at'),
	Literal('en-ca'),
	Literal('en-de'),
	Literal('en-es'),
	Literal('en-fr'),
	Literal('en-hk'),
	Literal('en-it'),
	Literal('en-nl'),
	Literal('en-pl'),
	Literal('en-th'),
	Literal('en-au'),
	Literal('en-dk'),
	Literal('en-gb'),
	Literal('en-id'),
	Literal('en-ie'),
	Literal('en-my'),
	Literal('en-no'),
	Literal('en-nz'),
	Literal('en-ph'),
	Literal('en-pt'),
	Literal('en-se'),
	Literal('en-sg'),
	Literal('en-us'),
	Literal('es-es'),
	Literal('es-mx'),
	Literal('fr-ch'),
	Literal('fr-be'),
	Literal('fr-ca'),
	Literal('fr-fr'),
	Literal('in-id'),
	Literal('it-ch'),
	Literal('it-it'),
	Literal('ko-kr'),
	Literal('nl-be'),
	Literal('nl-nl'),
	Literal('pl-pl'),
	Literal('pt-pt'),
	Literal('th-th'),
	Literal('zh-hk'),
)

export const StorefrontEnvironmentsUnion = Union(
	Literal('bfgp-025'),
	Literal('bfgp-032'),
	Literal('default'),
	Literal('dev'),
	Literal('stg'),
	Literal('prod'),
)

export const EmailConfigRecord = Record({
	passcodeOnly: Boolean,
	showShopAppLink: Boolean,
	staticRoot: String.optional(),
})

export const ApplicationConfigRecord = Record({
	id: String,
	clientId: String,
	hideContinueAsGuest: Boolean.optional(),
	translationOverrides: Dictionary(Dictionary(String, String), LocalesUnion).optional(),
})

export const BrandConfigRecord = Record({
	id: BrandsUnion,
	emails: Dictionary(EmailConfigRecord, EmailsUnion),
	hideFormElements: Dictionary(Array(String).optional(), ContextViewsUnion).optional(),
	name: String,
	locales: Array(LocalesUnion),
	storefrontUrls: Dictionary(String.optional(), StorefrontEnvironmentsUnion).optional(),
})

const OktaConfigRecord = Record({
	host: String,
})

const S3ConfigRecord = Record({
	bucket: String,
	url: String,
})

export const ConfigRecord = Record({
	applications: Dictionary(ApplicationConfigRecord, ApplicationsUnion),
	brands: Dictionary(BrandConfigRecord, BrandsUnion),
	okta: OktaConfigRecord,
	s3: S3ConfigRecord,
})
